<div id="language-selection-pop">
  <div id="close-btn" (click)="closeLanguagePicker()">
    <span class="icon icon_close"></span>
  </div>

  <div class="pg-inner-pop">
    <div class="pg-title">
      <h2>{{ 'CP_LM_LANDINGPAGE_SELECTLANG' | translate }}</h2>
    </div>

    <div class="language-selection">
      <div class="langage-list global">
        <h5>
          <span>{{ 'CP_LM_LANDINGPAGE_ALLANG' | translate }}</span>
        </h5>

        @if (allLanguages.length) {
          <ul class="language">
            @for (language of allLanguages; track language.localeCode) {
              <li class="clm-3 clm-tab-8">
                <a>
                  <span
                    id="locale-desc"
                    class="enable-selection"
                    [class.font-bold]="language.localeCode === selectedLanguage"
                    (click)="switchLanguage(language.localeCode)"
                  >
                    {{ language.localeDescription }}
                  </span>
                </a>
              </li>
            }
          </ul>
        } @else {
          <p>No languages available.</p>
        }
      </div>
    </div>
  </div>
</div>
